import React from 'react';
import { Col, Row, Typography, Layout } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import TramittaLogo from '../../images/tramitta-logo.png';
import LegalChileLogo from '../../images/legalchile.svg';

const { Title } = Typography;
const { Header } = Layout;

const FailAccess = () => {

  return (
    <>
      <Header className="header-container">
        <Row className="header-logos mb-0">
          <img src={LegalChileLogo} alt="" className="legal-logo" />
          <img src={TramittaLogo} alt="" className="tramitta-logo" />
        </Row>
      </Header>
      <div className="text-center">
        <Row className="mb-4">
          <Col md={12} className="mx-auto">
            <ExclamationCircleOutlined style={{ fontSize: '56px', color: '#42EDBA' }} className="mb-4" />
            <Title level={2}>Este link no es válido</Title>
            <p className="mb-2">Tu contrato no está habilidato para ser editado o ya fue editado.</p>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default FailAccess;